<template>
    <div class="goodscategory spackage padding-20 bgc box-shadow" v-loading="loading">
        <section class="gc-header">
            <el-button type="primary" align="left" @click="createGC">新增分类</el-button>
            <div align="right" style="float:right">
                <el-input placeholder="请输入分类名称" v-model="searchName" style="width: 240px"></el-input>
                <el-button type="primary" @click="searchGC()" plain>搜索</el-button>
            </div>
        </section>

        <section>
            <el-table :data="tableData" header-row-class-name="tableHead">
                <el-table-column prop="index" label="序号" align="left" width="100"></el-table-column>
                <el-table-column prop="name" label="分类名称" align="center" width="180"></el-table-column>
                <el-table-column prop="materialcount" label="商品数量" align="center"></el-table-column>
                <el-table-column prop="datetime" label="创建时间" align="center"></el-table-column>
                <el-table-column prop="memo" label="分类说明" align="center"></el-table-column>
                <el-table-column label="操作" align="right" width="150">
                    <template slot-scope="scope">
                        <div class="table-position">
                            <el-button @click="editGC(scope.row.innerid)">编辑</el-button>
                            <span>|</span>
                            <el-button @click="deleteGC(scope.row.innerid)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </section>
        <!-- end 表单 -->

        <!-- 编辑分类 弹窗 -- start -->
        <el-dialog :title="isEdit ? '编辑分类' : '新增分类'" :visible.sync="dialogFormVisible" @close="cancelCE" class="create_edit_dialog">
            <el-form :model="gcFormData" :rules="rules" ref="gcFormData">
                <el-form-item label="分类名称" :label-width="formLabelWidth" prop="name">
                    <el-input type="text" v-model="gcFormData.name" minLength="1" maxLength="8" autocomplete="off" placeholder="输入分类名称，不超过8个字" class="textStyle"></el-input>
                </el-form-item>
            </el-form>
            <el-form :model="form">
                <el-form-item label="分类说明" :label-width="formLabelWidth" prop="memo">
                    <el-input type="textarea" :rows="4" v-model="gcFormData.memo" maxLength="80" autocomplete="off" placeholder="输入分类说明，不超过80个字" class="textStyle"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelCE">取 消</el-button>
                <el-button type="primary" @click="sureAdd(currentid ? currentid : '')">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 编辑分类 弹窗 -- end -->

        <!-- 删除 确认 -- 弹窗 -- start -->
        <el-dialog title="提示" :visible.sync="deleteSureDialog" width="25%" class="dele_dialog">
            <span class="dele_tips delete_tips">确定要删除该分组？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteSureDialog = false">取 消</el-button>
                <el-button type="primary" @click="deleteGroup(currentid)">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 删除 确认 -- 弹窗 -- end -->

        <!-- 删除 -- 弹窗 -- start -->
        <el-dialog title="提示" :visible.sync="deleteDialog" width="25%" class="dele_dialog">
            <span class="dele_tips">当前分类下有商品存在，不能进行删除！</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteDialog = false, deleteSureDialog = false">取 消</el-button>
                <el-button type="primary" @click="deleteDialog = false, deleteSureDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 删除 -- 弹窗 -- end -->

        <section>
            <el-pagination background layout="prev,pager,next" :total="rowCount"  @current-change="fPage()" :current-page.sync="currentPage" align="center" style="margin-top:20px"></el-pagination>
        </section>
        <!-- end 分页 -->
        <!-- <div>111</div> -->
    </div>
</template>

<script>
import {getMaterialCategoryList, saveOrUpdateMaterialCategory, updateMaterialCategoryByStatus, getMaterialCategoryInfo} from '@/api/cPurchaseApi'
import {getCookie} from '@/common/js/tools'
import {mapActions} from 'vuex'
// import Page from 'base/page/page'
import $ from 'jquery'

export default {
    name: 'goodsCategory',
    data() {
        return {
            form: {},
            loading: false,
            token: getCookie('token'),
            sessionUser: JSON.parse(sessionStorage['user']),
            shopID: JSON.parse(sessionStorage['shop']).ShopID,
            selectValue: '',
            nameInput: '',
            currentPage: 1,
            rowCount: 0, // 数据条数
            page: 1, // 页数
            tableData: [], // 商品分类table数据
            dialogFormVisible: false,
            formLabelWidth: '80px',
            rules: {
                name: [
                    { required: true, message: '请输入分类名称', trigger: 'blur' }
                ]
            },
            gcFormData:{
                name: '',
                memo: ''
            },
            isEdit: false,
            currentid: '',
            searchName: '',
            deleteSureDialog: false,
            deleteDialog: false
        }
    },
    mounted() {
        this.setLoading(true)
        this.getGCList(1, this.searchName ? this.searchName : '')
    },
    methods: {
        // 新增商品分类
        createGC() {
            this.isEdit = false
            this.currentid = ''
            // this.gcFormData.name = ''
            // this.gcFormData.memo = ''
            this.dialogFormVisible = true
        },

        // 取消编辑或创建
        cancelCE() {
            this.dialogFormVisible = false
            this.gcFormData.name = ''
            this.gcFormData.memo = ''
        },

        // 获取商品分类列表
        getGCList(page, name) {
            let data = {
                name: name,
                page: page,
                pageSize: 10
            }
            this.setLoading(true)
            getMaterialCategoryList({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.rowCount = data.data.pageinfo.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        // 新增分组 接口调用
        sureAdd(id) {
            this.setLoading(true)
            let data = {
                innerid: id,
                name: this.gcFormData.name,
                memo: this.gcFormData.memo
            }
            saveOrUpdateMaterialCategory({
                data: data,
                success: data => {
                    this.setLoading(false)
                    this.dialogFormVisible = false
                    this.gcFormData.name = ''
                    this.gcFormData.memo = ''
                    this.$message.success('保存分类成功')
                    this.getGCList(1, this.searchName ? this.searchName : '')
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },

        // 编辑分类
        editGC(id) {
            this.isEdit = true
            this.dialogFormVisible = true
            this.currentid = id
            let data = {
                innerid: id
            }
            getMaterialCategoryInfo({
                data: data,
                success: data => {
                    this.gcFormData = data.data
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },

        // 删除分类
        deleteGC(id) {
            this.deleteSureDialog = true
            this.currentid = id
        },

        // 删除分组 接口调用
        deleteGroup(id) {
            let data = {
                innerid: id
            }
            updateMaterialCategoryByStatus({
                data: data,
                success: data => {
                    this.deleteSureDialog = false
                    this.$message.success('删除分类成功')
                    this.getGCList(1, this.searchName ? this.searchName : '')
                },
                error: data => {
                    this.setLoading(false)
                    if (data.code === '301') {
                        this.deleteDialog = true
                    }
                    
                }
            })
        },
        
        // 搜索分类
        searchGC() {
            this.setLoading(true)
            this.getGCList(1, this.searchName)
        },

        // 分页加载
        fPage() {
            this.setLoading(true)
            let clickPage = $('.el-pagination .active').html()
            this.getGCList(clickPage, this.searchName ? this.searchName : '')
        },

        ...mapActions([
            'setLoading'
        ])
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/starmgt";
    .tableHead {
        font-weight: bold;
    }
    .goodscategory {
        .create_edit_dialog {
            .el-dialog {
                width: 550px;
                height: 350px;
            }
            .el-dialog__body {
                padding: 20px 20px 0 20px;
            }
            .el-dialog__footer {
                padding: unset;
            }
            .el-input {
                width: 420px;
            }
        }
        .el-table {
            .sub-title {
                display: -webkit-box;
                max-height: 40px;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                -moz-box-orient: vertical;
                -ms-box-orient: vertical;
                box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        .el-textarea textarea {
            width: 420px;
            height: 130px;
            resize: none;
        }
        .gc-header {
            height: 40px;
            margin-bottom: 30px;
            .el-input__icon {
                height: 36px ;
            }
            .el-select,
            .el-select>.el-input,
            .el-button {
                height: 32px;
            }
            .el-select {
                width: 116px;
            }
            .el-select,
            .el-input {
                margin-right: 20px;
            }
        }
        .table-title {
            img {
                width: 106px;
                height: 60px;
            }

            .table-txt {
                display: block;
                width: calc(100% - 126px);
                height: 70px;
                p {
                    width: 100%;
                    height: 40px;
                }
            }

        }
        .table-position {
            .el-dropdown-link {
                a {
                    color: #303133;
                }
            }
        }
        .dele_dialog {
            border-radius: 4px;
            text-align: center;
            .dele_tips {
                color: #F56C6C;
            }
            .delete_tips {
                color: #666;
            }
        }
    }
</style>
